import { useState } from 'react';
import {
  InsuranceOptionalProduct,
  InsuranceOptionalSubProduct
} from '../CommonTypes';
import { ButtonContinue } from '../Button/ButtonContinue';
import { formatNumber } from '../Formatter';
import InsuranceDocumentLink from '../../sitePages/insurance/InsuranceDocumentLink';

interface InsuranceSubProductProps {
  product: InsuranceOptionalProduct;
  onProductChange: (updatedProduct: InsuranceOptionalProduct) => void;
}

const InsuranceOptionalProductComponent = ({
  product,
  onProductChange
}: InsuranceSubProductProps): JSX.Element => {
  const [showMore, setShowMore] = useState(false);

  const toggleOptionalProductSelection = () => {
    onProductChange({
      ...product,
      isOptionalProductSelected: !product.isOptionalProductSelected
    });
  };

  const removeSubProductSelection = (): void => {
    const updatedOptionalProductList: InsuranceOptionalSubProduct[] =
      product.optionalSubProductList.map((subProduct) => {
        return { ...subProduct, isOptionalSubProductSelected: false };
      });

    onProductChange({
      ...product,
      isOptionalProductSelected: false,
      optionalSubProductList: updatedOptionalProductList
    });
  };

  const updateSubProductSelection = (subProductTypeId: string) => {
    const updatedOptionalProductList: InsuranceOptionalSubProduct[] =
      product.optionalSubProductList.map((subProduct) => {
        if (subProduct.optionalSubProductId === subProductTypeId) {
          return { ...subProduct, isOptionalSubProductSelected: true };
        } else {
          if (subProduct.isOptionalSubProductSelected) {
            return { ...subProduct, isOptionalSubProductSelected: false };
          } else {
            return subProduct;
          }
        }
      });

    onProductChange({
      ...product,
      isOptionalProductSelected: true,
      optionalSubProductList: updatedOptionalProductList,
      optionalProductPrice: updatedOptionalProductList
        .filter((x) => x.isOptionalSubProductSelected === true)
        .reduce((a, b) => a + b.optionalSubProductPrice, 0)
    });
  };

  const subProductIsSelected = product.optionalSubProductList.some(
    (sp) => sp.isOptionalSubProductSelected
  );

  return (
    <div>
      <div className='one-col'>
        <h4 className='section-header m3-top'>{product.optionalProductName}</h4>
        <p>{product.optionalProductLessDescription}</p>
        {showMore && <p>{product.optionalProductMoreDescription}</p>}
        <div className='optional-product-link'>
          <a onClick={() => setShowMore(!showMore)}>
            {showMore ? 'Show less >' : 'Show more >'}
          </a>
        </div>
      </div>
      {product.optionalProductPolicyDocumentId && (
        <div className='one-col optional-product-link'>
          <InsuranceDocumentLink
            displayText={'Policy Document >'}
            documentId={product.optionalProductPolicyDocumentId}
          />
        </div>
      )}
      {product.optionalProductIPIDStatementDocumentId && (
        <div className='one-col optional-product-link'>
          <InsuranceDocumentLink
            displayText={'IPID >'}
            documentId={product.optionalProductIPIDStatementDocumentId}
          />
        </div>
      )}
      {product.optionalProductPrice !== 0 && (
        <div className='one-col optional-product-link'>
          <p>{`£${formatNumber(product.optionalProductPrice, 2, 'en-GB')}`}</p>
        </div>
      )}
      {product.optionalSubProductList.map((subItem, index) => (
        <table
          key={`subproduct-${product.optionalProductId}-${subItem.optionalSubProductId}`}
          width='60%'>
          {index === 0 && (
            <tr>
              <td align='left' width='60%'>
                Type of car
              </td>
              <td align='left' width='40%'>
                28 days
              </td>
            </tr>
          )}
          {index === 0 && (
            <tr>
              <td colSpan={2}>
                <hr></hr>
              </td>
            </tr>
          )}
          <tr>
            <td align='left' width='60%'>
              {subItem.optionalSubProductName}
            </td>
            <td align='left' width='40%'>
              <input
                className='form-check-input'
                key={`car-${index}`}
                type='radio'
                value={subItem.optionalSubProductId}
                onChange={() =>
                  updateSubProductSelection(subItem.optionalSubProductId)
                }
                checked={subItem.isOptionalSubProductSelected}
                id={`select-${index}-radio`}
              />
              {` £${formatNumber(subItem.optionalSubProductPrice, 2, 'en-GB')}`}
            </td>
          </tr>
          <tr>
            <td colSpan={2}>
              <hr></hr>
            </td>
          </tr>
        </table>
      ))}
      {product.optionalSubProductList.length === 0 && (
        <ButtonContinue
          name='btn-add'
          text={product.isOptionalProductSelected ? 'Remove' : 'Add'}
          onClick={toggleOptionalProductSelection}
          additionalClassNames='btn-ok'
        />
      )}
      {subProductIsSelected && (
        <ButtonContinue
          name='btn-remove'
          text='Remove'
          onClick={removeSubProductSelection}
          additionalClassNames='btn-cancel'
        />
      )}
    </div>
  );
};

export default InsuranceOptionalProductComponent;
